export interface ContextMenuPosition {
    x: number;
    y: number;
}

/**
 * Positions a menu at the pointer that invoked it while keeping it reachable
 * near viewport edges. The caller supplies the expected menu size because the
 * menu has not rendered yet.
 */
export function positionContextMenu(
    pointer: { x: number; y: number },
    viewport: { width: number; height: number },
    menu: { width: number; height: number },
    margin = 8
): ContextMenuPosition {
    const maxX = viewport.width - menu.width - margin;
    const maxY = viewport.height - menu.height - margin;
    const x = Math.max(margin, Math.min(pointer.x, maxX));
    const y = Math.max(margin, Math.min(pointer.y, maxY));

    return { x, y };
}
